import ProductEvents from "./product-events";
let unsubscribe;
export function registerIntercomEventConsumer() {
    if (typeof window.Intercom !== 'function') {
        return () => { };
    }
    if (unsubscribe) {
        return unsubscribe;
    }
    unsubscribe = ProductEvents.on('inspection:opened', ({ id }) => {
        try {
            window.Intercom('trackEvent', 'inspection-opened', { id });
        }
        catch (error) {
            window.Sentry?.captureException(error);
        }
    });
    return unsubscribe;
}
